module.exports = __webpack_public_path__ + "img/ccm_pic_5.073618c5.jpg";